var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCctv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.374 24.346C41.4532 24.1658 41.4962 23.9719 41.5004 23.7751C41.5046 23.5784 41.47 23.3828 41.3985 23.1994C41.327 23.0161 41.2201 22.8486 41.0839 22.7066C40.9476 22.5647 40.7847 22.4509 40.6045 22.372L20.992 13.738C19.4995 13.081 17.662 13.8145 17.0245 15.301L13.7095 23.032C13.3976 23.7633 13.3886 24.5884 13.6845 25.3263C13.9803 26.0642 14.5568 26.6546 15.2875 26.968L24.3445 30.85L22.4845 35.5H16V31H13V43H16V38.5H22.4845C23.719 38.5 24.8125 37.759 25.2685 36.613L27.1015 32.032L34.909 35.377C35.2726 35.533 35.6831 35.539 36.0512 35.3938C36.4192 35.2485 36.715 34.9638 36.874 34.6015L37.342 33.5365L39.8935 34.5565L42.8935 27.0565L40.5895 26.137L41.374 24.346ZM34.723 32.035L16.4695 24.2125L19.7815 16.4845L38.0245 24.5155L34.723 32.035Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctv);
export default __webpack_public_path__ + "static/media/cctv.411b6cb60de95a070e7801c7a2aac962.svg";
export { ForwardRef as ReactComponent };